import * as React from "react";
import {cx}       from "emotion";

import "./idml-upload-unsupported-features.scss";

import {ComponentLink,
        Link,
        makeChain}     from "@Common/react/cst2";
import {Types}         from "@Common/types";


export const IdmlUploadUnsupportedFeatures = ({
    warnings,
    onComplete,
}:{
    warnings    : any[],
    onComplete  : () => void,
}) => (

    makeChain<JSX.Element>()

    // render view
    .then(({}) => (
        <div className="idml-upload-unsupported-features-op6">
            <div className="content">
                <h2>Your template uses unsupported features.</h2>
                <p>
                    We don't support the following InDesign features. You can{" "}
                    <a href="#new-template" onClick={(e) => {e.preventDefault(); window.location.hash = "#new-template"}}
                        xd-qa-type="link" xd-qa-name="New Template Upload Again"
                    >return to upload</a> after adjusting your IDML or you may continue anyway.
                </p>
                <ol className="warnings">
                    {warnings.map((warning, index) => (
                        <li key={warning.id}>
                            <h3>{warning.title}</h3>
                            <p>{warning.description}</p>
                        </li>
                    ))}
                </ol>
            </div>
            <div className="button-bar">
                <button
                    onClick={onComplete}
                    xd-qa-type="button" xd-qa-name="New Template Upload Accept Unsupported Features"
                >
                    Accept & Continue
                </button>
            </div>
        </div>
    ))

    .run()

);
